﻿import React, { useState, useEffect } from "react";
import { Search } from "lucide-react";
import { api } from "../utils/api.js";
import { getCompany, rememberCompanies, useCompanyInfoVersion } from "../utils/companyInfo.js";

export default function AddCompaniesModal({ selected, onToggle, onClose }) {
  useCompanyInfoVersion();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const q = query.trim();
    if (!q) {
      setResults([]);
      return undefined;
    }
    let dead = false;
    setLoading(true);
    const timer = setTimeout(() => {
      api(`/search?q=${encodeURIComponent(q)}&limit=30`)
        .then((rows) => {
          if (dead) return;
          rememberCompanies(rows);
          setResults(rows);
          setLoading(false);
        })
        .catch(() => {
          if (!dead) {
            setResults([]);
            setLoading(false);
          }
        });
    }, 200);
    return () => {
      dead = true;
      clearTimeout(timer);
    };
  }, [query]);

  const rows = query.trim() ? results : selected.map((t) => getCompany(t) || { ticker: t, name: t, sector: "" });

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card add-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Add companies</h3>

        <div className="dash-search-wrap">
          <Search size={16} className="add-search-icon" />
          <input
            type="text"
            className="form-control add-search-input"
            placeholder="Search any US company by name or ticker"
            value={query}
            autoFocus
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        {!query.trim() && <div className="small text-muted mt-2">{selected.length ? "In this watchlist (untick to remove):" : "Type a name or ticker, e.g. Apple or NVDA."}</div>}

        <ul className="add-list">
          {rows.map((c) => (
            <li key={c.ticker}>
              <label className="add-row">
                <input type="checkbox" checked={selected.includes(c.ticker)} onChange={() => onToggle(c.ticker)} />
                <span className="fw-bold">{c.name}</span>
                <span className="text-muted small">{c.ticker}</span>
                {c.sector && <span className="badge badge-purple ms-auto">{c.sector}</span>}
              </label>
            </li>
          ))}
          {query.trim() && !loading && rows.length === 0 && <li className="text-muted p-3">No companies found.</li>}
          {loading && <li className="text-muted p-3">Searching...</li>}
        </ul>

        <div className="modal-actions">
          <button className="btn btn-purple" onClick={onClose}>DONE</button>
        </div>
      </div>
    </div>
  );
}
